export default __webpack_public_path__ + "static/media/cheatday_3.f6152ccf.jpg";